import { useMutation, useQueryClient } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import { teamsQueryKeys } from "./queryKeyFactory";

export const useDeleteTeamMutation = () => {
    const queryClient = useQueryClient();

    return useMutation<void, Error, number>({
        mutationFn: (teamId) => salesApiService.teams.deleteTeam(teamId),
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: teamsQueryKeys.all(), exact: true });
        },
    });
};
